import type { JSX, SVGProps } from 'react';
import { memo } from 'react';

export type IconSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export const NUMERIC_SIZES: Record<IconSize, number> = {
  xs: 12,
  sm: 16,
  md: 24,
  lg: 32,
  xl: 40,
};

export type RIconComponent = (props: SVGProps<SVGSVGElement>) => JSX.Element;

export interface RIconProps extends SVGProps<SVGSVGElement> {
  icon: RIconComponent | string;
  size?: IconSize | number;
  color?: string;
  className?: string;
  'data-testid'?: string;
}

export const RIcon = ({
  icon,
  size = 'sm',
  color = 'currentColor',
  className,
  ...rest
}: RIconProps) => {
  const numericSize = typeof size === 'string' ? NUMERIC_SIZES[size] : size;

  if (typeof icon === 'string') {
    return (
      <div
        style={{
          width: numericSize,
          height: numericSize,
          backgroundColor: color,
          maskImage: `url(${process.env.REACT_APP_STATIC_URL}/images/icons/${icon}.svg)`,
          WebkitMaskImage: `url(${process.env.REACT_APP_STATIC_URL}/images/icons/${icon}.svg)`,
        }}
        data-testid={rest['data-testid']}
        className={className}
      />
    );
  }

  const Icon = icon; // Pascal case if `icon` is a component

  return (
    <Icon
      width={numericSize}
      height={numericSize}
      fill={color}
      style={{ flex: 'none' }}
      className={className}
      {...rest}
    />
  );
};

export default memo(RIcon);
